// imports
import { combineReducers } from 'redux';
import { persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import moment from 'moment';

// local reducers
import navigation from './navigationReducer';
import things from './thingReducer';
import places from './placeReducer';
import people from './personReducer';
import peripherals from './peripheralReducer';
import readings from './readingsReducer';
import user from './userReducer';
import reports from './reportReducer';
import search from './searchReducer';
import maps from './mapsReducer';
import trigger from './triggerReducer';
import progressBar from './progressBarReducer';
import contactTracing from './contactTracingReducer';
import dock from './dockReducer';
import favorites from './favoritesReducer';
import userPrefs from './userPrefsReducer';
import auth, { AUTH_LOGOUT } from './authReducer';
import grids from './gridsReducer';
import app from './appReducer';

const appReducer = combineReducers({
  navigation,
  things,
  places,
  people,
  peripherals,
  readings,
  reports,
  user,
  search,
  maps,
  trigger,
  progressBar,
  contactTracing,
  dock,
  favorites,
  userPrefs,
  auth,
  app,
  grids,
});

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT' || action.type === AUTH_LOGOUT) {
    state = undefined;
  }

  return appReducer(state, action);
};

// https://stackoverflow.com/questions/12756159/regex-and-iso8601-formatted-datetime
const ISO_8601_FULL = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i;

// tranform moments from iso to moment
const momentTransform = createTransform(
  // transform state on its way to being serialized and persisted.
  (inboundState) => {
    const saveState = {};
    for (let key in inboundState) {
      const value = inboundState[key];
      if (moment.isMoment(value)) {
        saveState[key] = value.toISOString();
      } else {
        saveState[key] = value;
      }
    }

    return saveState;
  },
  // transform state being rehydrated
  (outboundState) => {
    const hydratedState = {};
    for (let key in outboundState) {
      const value = outboundState[key];
      if (ISO_8601_FULL.test(value)) {
        hydratedState[key] = moment(value);
      } else {
        hydratedState[key] = value;
      }
    }

    return hydratedState;
  },
);

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['navigation', 'contactTracing', 'search', 'userPrefs', 'auth', 'app'], // reducer keys to persist
  transforms: [momentTransform],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;

export * from './contactTracingReducer';
export * from './searchReducer';
export * from './dockReducer';
export * from './favoritesReducer';
export * from './userPrefsReducer';
export * from './authReducer';
export * from './appReducer';
export * from './gridsReducer';
export * from './navigationReducer';
